import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { CustomHttpClient } from './custom-http-client.service';
import { HttpParams } from '@angular/common/http';
import { UpdoxUser } from '../routes/practices/updox-integration/updox-user';

@Injectable({
  providedIn: 'root'
})
export class UpdoxService {
  // Realtime secure-messaging state — fed by UserChannel broadcasts routed
  // through app.component, read by the header badge and folder list.
  unreadInboxCount = 0;
  inboundMessage: Subject<any> = new Subject<any>();

  constructor(private http: CustomHttpClient) {}

  getUpdoxUser(practiceId: number): Promise<any> {
    let params = new HttpParams().set('practice_id', String(practiceId));
    return this.http.get('updox/get_updox_users', { params }).toPromise();
  }

  saveUser(updoxUser: UpdoxUser): Promise<any> {
    return this.http.post('updox/save_user', updoxUser.to_params()).toPromise();
  }

  updateUser(updoxUser: UpdoxUser): Promise<any> {
     return this.http.post('updox/save_user', updoxUser.to_params()).toPromise();
  }

  // Same practice resolution used by UpdoxMessagingComponent.
  practiceIdFor(user: any): number {
    if (!user) { return null; }
    return (user.practices_id && user.practices_id.length > 0)
      ? user.practices_id[0]
      : (user.profileable && user.profileable.practice_id) || user.profileable_id;
  }

  loadUnreadCount(practiceId: number): void {
    if (!practiceId) { return; }
    const params = new HttpParams().set('practice_id', String(practiceId));
    this.http.get('updox/unread_count', { params }).toPromise()
      .then((resp: any) => this.setUnreadCount(resp && resp.unread_inbox_count))
      .catch(() => {});
  }

  setUnreadCount(count: number): void {
    this.unreadInboxCount = count || 0;
  }

  handleInboundMessage(broadcasting: any): void {
    this.setUnreadCount(broadcasting.unread_inbox_count);
    this.inboundMessage.next(broadcasting.updox_message);
  }

  resetYourSelf(): void {
    this.unreadInboxCount = 0;
  }
}
